import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import {
  CreateKpiSidePanelWrapper,
  ViewKpiSidePanelWrapper,
} from '../components';
import { useCreateKpiModalListener, useViewKpiModalListener } from '../hooks';
import { KpiUpdatesDialogProvider } from '../providers';

export function KpiCrudApp() {
  const {
    isOpen: shouldShowCreateModal,
    teamId: createKpiTeamId,
    location: createKpiLocation,
    handleClose: closeCreateModal,
  } = useCreateKpiModalListener();
  const {
    isOpen: shouldShowViewModal,
    kpiId: viewKpiId,
    location: viewKpiLocation,
    handleClose: closeViewModal,
  } = useViewKpiModalListener();
  const kpisEnabled = window.wbConfig.isKpisEnabled ?? false;

  return kpisEnabled ? (
    // resetKeys: without it a single crash inside the KPI drawer leaves the
    // boundary stuck rendering null — the KPI panel can never be reopened
    // until a full page refresh. Resetting on modal state lets the next
    // open attempt remount cleanly.
    <ErrorBoundary
      fallbackRender={() => null}
      resetKeys={[
        shouldShowViewModal,
        viewKpiId,
        viewKpiLocation,
        shouldShowCreateModal,
        createKpiTeamId,
        createKpiLocation,
      ]}
    >
      <Suspense fallback={null}>
        <KpiUpdatesDialogProvider>
          <CreateKpiSidePanelWrapper
            open={shouldShowCreateModal}
            teamId={createKpiTeamId}
            location={createKpiLocation}
            onClose={closeCreateModal}
          />
          {viewKpiId && (
            <ViewKpiSidePanelWrapper
              open={shouldShowViewModal}
              kpiId={viewKpiId}
              location={viewKpiLocation}
              onClose={closeViewModal}
            />
          )}
        </KpiUpdatesDialogProvider>
      </Suspense>
    </ErrorBoundary>
  ) : null;
}
